import type { Location } from "react-router";

type RouterLocation = Location | Pick<Location, "pathname" | "search" | "hash">;

let locationSnapshot: RouterLocation = {
  pathname: typeof window === "undefined" ? "/" : window.location.pathname,
  search: typeof window === "undefined" ? "" : window.location.search,
  hash: typeof window === "undefined" ? "" : window.location.hash
};

export const setCurrentLocation = (location: RouterLocation) => {
  locationSnapshot = location;
};

export const currentLocation = () => locationSnapshot as Location;
